import permissions from './role.config';
import { getAccessMenuOld, getAccessMenu, formatPath } from './util';
import { switchKeys, getSwitch } from '../swtichs';

export const loginPath = '/league/login';
export const pagePath = '/league/admin';

function isLoginPath(path) {
    return path === loginPath;
}

function havePermission(userRole) {
    return userRole > permissions.no;
}

export function openLoginPage() {
    window.location.href = loginPath;
}

function handler(store, router, userInfo, hasRoutes) {
    const userRole = userInfo.userRole;
    const tabResourceList = userInfo.tabResourceList;
    if (havePermission(userRole)) {
        const accessMenu = getAccessMenu(router.options.__ks_dynamic_routes__, tabResourceList, pagePath);
        const newRoutes = router.options.__ks_dynamic_routes__.filter(item => {
            const path = `${pagePath}${item.path}`;
            const temp = tabResourceList.filter(list => {
                return formatPath(list.resourceUrl).indexOf(path) > -1;
            });
            return temp.length;
        });
        store.dispatch('updateMenu', accessMenu);
        if (!hasRoutes) {
            router.addRoutes(newRoutes);
        }
    }
}

export function addClientRoutes(store, router) {
    const userRole = store.state.userInfo.userRole;
    const tabResourceList = store.state.userInfo.tabResourceList;

    handler(store, router, store.state.userInfo, false);

    router.beforeEach((to, from, next) => {
        const bool = [/^\/$/, /^\/league\/?$/, /^\/league\/admin\/?$/].find(url => url.test(to.redirectedFrom || to.path));
        if (bool) {
            if (userRole === permissions.distributor) {
                router.replace({ path: '/yellowcar/' });
            } else if (userRole === permissions.employee) {
                router.replace({ path: formatPath(tabResourceList[0].resourceUrl).replace(pagePath, '') });
            } else if (userRole) {
                router.replace({ path: '/goods/' });
            } else {
                next();
            }
        } else {
            next();
        }
    });
    router.afterEach((to, from) => {
        const matchedComponents = router.getMatchedComponents();
        if (!matchedComponents.length) {
            router.push({ path: '/notfound' });
        } else {
            const menu = store.state.menu.menu || {};

            for (const key in menu) {
                const children = menu[key].children;
                // 存在子路由（子菜单）
                if (Object.keys(children).length > 0) {
                    for (const ckey in children) {
                        // eslint-disable-next-line max-depth
                        if (to.path.indexOf(children[ckey].path) === 0) {
                            store.dispatch('updateDefaultValue', `${children[ckey].path}`);
                            break;
                        }
                    }
                } else if (to.path === menu[key].path) {
                    store.dispatch('updateDefaultValue', menu[key].path);
                    break;
                }
            }
        }
    });
}

function handlerOld(store, router, userRole, hasRoutes) {
    if (havePermission(userRole)) {
        const accessMenu = getAccessMenuOld(router.options.__ks_dynamic_routes__, userRole);
        const newRoutes = router.options.__ks_dynamic_routes__.filter(item => {
            return item.meta ? item.meta?.role.includes(userRole) : true;
        });
        store.dispatch('updateMenu', accessMenu);
        if (!hasRoutes) {
            router.addRoutes(newRoutes);
        }
    }
}

export function addClientRoutesOld(store, router) {
    const userRole = store.state.userInfo.userRole;
    handlerOld(store, router, userRole, false);

    router.beforeEach((to, from, next) => {
        const bool = [/^\/$/, /^\/league\/?$/, /^\/league\/admin\/?$/].find(url => url.test(to.redirectedFrom || to.path));
        if (bool) {
            if (userRole === permissions.distributor) {
                router.replace({ path: '/yellowcar/' });
            } else if (userRole) {
                router.replace({ path: '/goods/' });
            } else {
                next();
            }
        } else {
            next();
        }
    });
    router.afterEach((to, from) => {
        const matchedComponents = router.getMatchedComponents();
        if (!matchedComponents.length) {
            router.push({ path: '/notfound' });
        } else {
            const menu = store.state.menu.menu || {};

            for (const key in menu) {
                const children = menu[key].children;
                // 存在子路由（子菜单）
                if (Object.keys(children).length > 0) {
                    for (const ckey in children) {
                        /* eslint-disable max-depth */
                        if (to.path.indexOf(children[ckey].path) === 0) {
                            store.dispatch('updateDefaultValue', `${children[ckey].path}`);
                            break;
                        }
                    }
                } else if (to.path === menu[key].path) {
                    store.dispatch('updateDefaultValue', menu[key].path);
                    break;
                }
            }
        }
    });
}

export function addServerRoutes(store, router, context) {
    const userRole = context.state.userInfo.userRole;
    handler(store, router, userRole, false);
}
export const addRoutes = EASY_ENV_IS_NODE
    ? addServerRoutes
    : (
        getSwitch(switchKeys.UPM)
            ? addClientRoutes
            : addClientRoutesOld
    );
